import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import ListItem from "../ListItem/ListItem";

const MenuItem = props => ___EmotionJSX(ListItem, props);

MenuItem.defaultProps = {
  icon: null,
  size: 'small',
  primaryText: '',
  onClick: null,
  component: 'li',
  className: undefined
};
MenuItem.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  icon: PropTypes.elementType,
  primaryText: PropTypes.string,
  onClick: PropTypes.func,
  component: PropTypes.elementType,
  className: PropTypes.string
};
export default MenuItem;